import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ReplaySubject, merge } from 'rxjs';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { ListComponent } from '../list';
import { PersonPointOfContact } from '../../models/person-point-of-contact';

@Component({
  selector: 'lib-point-of-contact-list',
  templateUrl: './point-of-contact-list.component.html',
  styleUrls: ['./point-of-contact-list.component.scss'],
  animations: [
    trigger('statusChange', [
      state(
        'Pending',
        style({
          backgroundColor: '#FDEED4',
        })
      ),
      state(
        'Active',
        style({
          backgroundColor: 'white',
        })
      ),
      state(
        'Rejected',
        style({
          backgroundColor: 'white',
        })
      ),
      transition('Pending => Active', [
        animate(
          '2s ease-in-out',
          keyframes([
            style({ backgroundColor: '#00C25B26', offset: 0.1 }),
            style({ backgroundColor: '#00C25B26', offset: 0.7 }),
            style({ backgroundColor: 'white', offset: 1 }),
          ])
        ),
      ]),
      transition('Pending => Rejected', [
        animate(
          '2s ease-in-out',
          keyframes([
            style({ backgroundColor: '#FF000026', offset: 0.1 }),
            style({ backgroundColor: '#FF000026', offset: 0.7 }),
            style({ backgroundColor: 'white', offset: 1 }),
          ])
        ),
      ]),
    ]),
  ],
})
export class PointOfContactListComponent extends ListComponent<PersonPointOfContact> implements OnInit {
  static readonly activeStatus = 'Active';
  static readonly pendingStatus = 'Pending';
  @Input() isStaffView: boolean;

  emptyList$ = new ReplaySubject<PersonPointOfContact[]>(1);
  columns = ['name', 'email', 'title', 'requestInfo', 'actions', 'menu'];

  constructor() {
    super();
  }

  ngOnInit() {
    this.hideOnEmpty = true;
    this.listToUse$ = merge(this.list$, this.emptyList$);
    super.ngOnInit();
  }

  getRequestLabel(poc: PersonPointOfContact): string {
    if (poc.isPending) return 'Access Pending';
    if (poc.isActive) return 'Access Approved';
    if (poc.isRejected) return 'Access Denied';

    return '';
  }

  getRequestDate(poc: PersonPointOfContact): Date {
    if (poc.isPending) return poc.requestExpirationDate;
    if (poc.isActive) return poc.acceptedDate;
    if (poc.isRejected) return poc.endDate;

    return null;
  }

  staffViewRoute(poc: PersonPointOfContact) {
    return ['/person', poc.pointOfContactPerson.id];
  }
}
